import { toast } from "react-toastify";
import { apicall } from "../../services/api";
import { Toastify } from "../../services/toastify/toastifyContainer";
import {
	CAMPAIGN_PROMO,
	ALL_PROMO_BATCH,
	CREATE_PROMO_BATCH,
	REMOVE_PROMO_BATCH,
	ALL_PROMO,
	REMOVE_PROMO,
	ERR_PROMO,
	UPDATE_PROMO,
	UPDATE_ERR_PROMO,
	CREATE_PROMO_BATCH_LOADING,
} from "./actionTypes";
import { setAlert } from "./alert.actions";

export const getAllCampaignPromo = () => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/campaign_promo/campaigns/all/`, "get");
		dispatch({
			type: CAMPAIGN_PROMO,
			payload: res.data.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_PROMO,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert("Unable to fetch data", "error"));
	}
};

export const getAllPromoBatch = () => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/campaign_promo/`, "get");
		dispatch({
			type: ALL_PROMO_BATCH,
			payload: res.data.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_PROMO,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert("Unable to fetch data", "error"));
	}
};

export const getAllPromos = (campaign_batch_id, page_no, seacrh) => async (dispatch) => {
	// console.log(page_no, "hello")
	try {
		const res = await apicall(`api/v1/campaign_promo/${campaign_batch_id}?page=${page_no}&limit=10&search=${seacrh || ""}`, "get");

		dispatch({
			type: ALL_PROMO,
			payload: res.data.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_PROMO,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert("Unable to fetch data", "error"));
	}
};

export const createPromoBatch = (formData) => async (dispatch) => {

	try {
		dispatch({ type: CREATE_PROMO_BATCH_LOADING });
		const res = await apicall("api/v1/campaign_promo/", "post", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				"Access-Control-Allow-Origin": "*",
			},
		});

		dispatch({
			type: CREATE_PROMO_BATCH,
			payload: res.data.data,
		});
		dispatch(getAllPromoBatch());
		localStorage.removeItem("loading");
		toast.success(res.data.message);
	} catch (err) {
		localStorage.removeItem("loading");
		dispatch({
			type: ERR_PROMO,
			payload: { msg: err.response.data.msg, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};



export const deletePromoBatch = (campaign_batch_id) => async (dispatch) => {
	if (window.confirm("Are you sure? This can NOT be undone!")) {
		try {
			const res = await apicall(
				`api/v1/campaign_promo/${campaign_batch_id}`,
				"delete"
			);

			dispatch({ type: REMOVE_PROMO_BATCH, payload: campaign_batch_id });
			dispatch(setAlert("Promo batch deleted successfully", "success"));
			return res
		} catch (err) {
			dispatch({
				type: ERR_PROMO,
				payload: { msg: err.response.statusText, status: err.response.status },
			});
			dispatch(setAlert("Unable to delete promo batch", "error"));
		}
	}
};
export const updatePromo = (promoArr) => async (dispatch) => {
	try {
		let { assigned, campaign_batch_id, campaign_id, client_promo_id, id, createdAt, created_by, deleted_by, is_deleted, status, updatedAt, updated_by, ...newPromoArr } = promoArr;
		newPromoArr.consumption_count = parseInt(newPromoArr.consumption_count);
		newPromoArr.total_count = parseInt(newPromoArr.total_count);

		let { updateId, ...data } = newPromoArr;

		const res = await apicall(`api/v1/campaign_promo/updatePromo/${newPromoArr?.updateId}`, "patch", data);

		dispatch({ type: UPDATE_PROMO, payload: res.data });
		Toastify({ data: "success", msg: res.data.message });
		return res?.data
	} catch (err) {
		dispatch({
			type: UPDATE_ERR_PROMO,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		Toastify({ data: "error", msg: err.response.statusText });
	}
};

export const deletePromo = (promoArr) => async (dispatch) => {
	// if (window.confirm("Are you sure? This can NOT be undone!")) {
	try {
		const res = await apicall(`api/v1/campaign_promo/`, "delete", promoArr);
		dispatch({ type: REMOVE_PROMO, payload: res.data.data.client_promo_id });
		Toastify({ data: "success", msg: "Promocode deleted successfully" })
		dispatch(getAllPromos(sessionStorage.getItem('promoId'), 1, ""));
	} catch (err) {
		dispatch({
			type: ERR_PROMO,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		// dispatch(setAlert("Unable to delete promo", "error"));
		Toastify({ data: "error", msg: "Unable to delete promo" })
	}
}
// };
